export const textStyle = {
  style: {
    color: 'var(--font)',
    fontFamily: 'SF Display',
    fontSize: '12px'
  }
}

export const DEFAULT_CHART_OPTIONS: Highcharts.Options = {
  title: {
    ...textStyle,
    text: null
  },
  chart: {
    animation: false,
    backgroundColor: 'var(--card)',
    plotBorderWidth: 0,
  },
  xAxis: {
    tickColor: 'var(--font)',
    type: 'datetime',
    lineColor: 'var(--divider)',
    dateTimeLabelFormats: {
        day: '%d %b %y',
    },
    labels: { ...textStyle },
    title: {...textStyle},
    minPadding: 0,
    maxPadding: 0,
  },
  yAxis: {
    tickColor: 'var(--font)',
    gridLineColor: 'var(--divider)',
    labels: { ...textStyle },
    title: {...textStyle}
  },
  legend: {
    title: {
      ...textStyle
    },
    itemStyle: {
      color: 'var(--font)'
    },
    itemHoverStyle: {
      color: 'var(--primary)'
    },
    verticalAlign: 'top',
  },
  tooltip: {
    shared: true,
    hideDelay: 0,
    animation: { duration: 0 },
    xDateFormat: '%d %b %y %H %M',
    backgroundColor: 'var(--card)',
    style: {
      color: 'var(--primary)'
    }
  },
  credits: { enabled: false },
  exporting: { enabled: false },
  time: { timezone: undefined },
  series: []
}

export const CS_LINE_CHART_OPTIONS: Highcharts.Options = {
  title: {
    ...textStyle,
    text: null
  },
  chart: {
    type: 'line',
    zooming: {
      type: 'x'
    },
    animation: false,
    backgroundColor: 'var(--card)',
    plotBorderWidth: 0,
  },
  xAxis: {
    tickColor: 'var(--font)',
    type: 'datetime',
    lineColor: 'var(--divider)',
    dateTimeLabelFormats: {
        day: '%d %b %y',
    },
    minPadding: 0,
    maxPadding: 0,
    labels: { ...textStyle }
  },
  yAxis: {
    tickColor: 'var(--font)',
    gridLineColor: 'var(--divider)',
    labels: { ...textStyle },
    title: {...textStyle}
  },
  legend: {
    title: {
      ...textStyle
    },
    itemStyle: {
      color: 'var(--font)'
    },
    itemHoverStyle: {
      color: 'var(--primary)'
    },
    verticalAlign: 'top',
  },
  tooltip: {
    shared: true,
    hideDelay: 0,
    animation: { duration: 0 },
    xDateFormat: '%d %b %y %H %M',
    backgroundColor: 'var(--card)',
    style: {
      color: 'var(--primary)'
    }
  },
  credits: { enabled: false },
  exporting: {
    enabled: false,
    sourceWidth: 2056,
    sourceHeight: 400,
    fallbackToExportServer: false,
    buttons: {
      contextButton: {
        menuItems: ['downloadPNG', 'downloadJPEG', 'downloadPDF', 'downloadXLS'],
        symbol: '',
        useHTML: true,
        theme: {
          fill: 'var(--background)'
        },
        text: `
          <i class="far fa-download font-icons pointer mr-2 text-primary"></i>
          <span class="pointer text-primary" > Export </span>
          <i class="fas cursor-pointer text-primary ml-2 font-size-small fa-chevron-down"></i>
        `
      }
    }
  },
  time: {
    timezone: undefined
  },
  series: []
}

export const CS_BAR_CHART_OPTIONS: Highcharts.Options = {
  chart: {
    type: 'column',
    animation: false,
    spacingRight: 20,
    height: 200,
    backgroundColor: 'var(--card)',
    plotBorderColor: 'var(--divider)',
    plotBorderWidth: 1,
  },
  title: {
    text: null
  },
  xAxis: {
    minPadding: 0,
    maxPadding: 0,
    tickColor: 'var(--font)',
    type: 'datetime',
    lineColor: 'var(--divider)',
    dateTimeLabelFormats: {
      day: '%d %b %y',
    },
    labels: { ...textStyle },
    title: {...textStyle}
  },
  yAxis: {
    minPadding: 0,
    maxPadding: 0,
    tickColor: 'var(--font)',
    gridLineColor: 'var(--divider)',
    labels: { ...textStyle },
    title: {...textStyle}
  },
  tooltip: {
    enabled: false,
    backgroundColor: 'var(--card)',
    style: {
      color: 'var(--primary)'
    }
  },
  legend: {
    enabled: false
  },
  plotOptions: {
    column: {
      borderWidth: 0,
      colorByPoint: false,
      dataLabels: {
        enabled: false,
        inside: false,
        shadow: false,
        ...textStyle,
      }
    }
  },
  time: {
    timezone: undefined
  },
  credits: { enabled: false },
  exporting: {
    enabled: false,
    sourceWidth: 2056,
    sourceHeight: 400,
    fallbackToExportServer: false,
    buttons: {
      contextButton: {
        menuItems: ['downloadPNG', 'downloadJPEG', 'downloadPDF', 'downloadXLS'],
        symbol: '',
        useHTML: true,
        theme: {
          fill: 'var(--background)'
        },
        text: `
          <i class="far fa-download font-icons pointer mr-2 text-primary"></i>
          <span class="pointer text-primary" > Export </span>
          <i class="fas cursor-pointer text-primary ml-2 font-size-small fa-chevron-down"></i>
        `
      }
    }
  },
  series: []
}

export const CS_AREA_CHART_OPTIONS: Highcharts.Options = {
  chart: {
    animation: false,
    zooming: {
      type: 'x'
    },
    height: 200,
    backgroundColor: 'var(--card)',
    plotBorderColor: 'var(--divider)',
    plotBorderWidth: 1,
  },
  title: {
    text: null
  },
  xAxis: {
    minPadding: 0,
    maxPadding: 0,
    tickColor: 'var(--divider)',
    type: 'datetime',
    lineWidth: 1,
    lineColor: 'var(--divider)',
    gridLineWidth: 1,
    gridLineColor: 'var(--divider)',
    labels: {
      style: {
        fontSize: '11px',
        fontFamily: 'SF Display',
        color: 'var(--font)',
      }
    },
  },
  yAxis: {
    title: {
      style: {
        fontSize: '12px',
        fontFamily: 'SF Display',
        color: 'var(--font)'
      }
    },
    tickColor: 'var(--font)',
    lineWidth: 1,
    lineColor: 'var(--divider)',
    gridLineWidth: 1,
    gridLineColor: 'var(--divider)',
    labels: {
      style: {
        color: 'var(--font)'
      }
    },
  },
  legend: {
    itemStyle: {
      color: 'var(--font)'
    },
    itemHoverStyle: {
      color: 'var(--primary)'
    }
  },
  plotOptions: {
    series: {
      animation: false,
      states: {
        hover: {
          animation: false,
          shadow: false,
          halo: {
            size: 0,
            opacity: 0
          }
        },
        inactive: {
          enabled: false
        }
      }
    }
  },
  time: {
    timezone: undefined
  },
  credits: { enabled: false },
  exporting: { enabled: false }
};

